<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="mb-24">
            <h2 class="u-text-normal mb-12">
                Papierkorb <span class="text-light">({{ documents.length }})</span>
            </h2>
            <app-button
                v-if="documents.length"
                icon="trashcan"
                size="small"
                @click.native="showConfirmModal = true"
            >Leeren</app-button>
        </div>

        <loading-overlay :active="isLoading">
            <div v-if="documents.length" class="u-flex u-flex-wrap pb-24">
                <document-thumb
                    v-for="document in documents"
                    :key="document.id"
                    v-bind="document"
                    persist-delete
                    @delete="onDeleteDocument"
                />
            </div>
            <div v-else-if="!isLoading" class="u-flex u-flex--center u-flex-grow pt-56">
                <div class="u-text-center">
                    <app-icon name="trashcan" :scale="4" hidden class="mb-12"/>
                    <p class="text-mute">Dein Papierkorb ist leer.</p>
                </div>
            </div>
        </loading-overlay>

        <confirm-modal
            v-if="showConfirmModal"
            v-model="showConfirmModal"
            headline="Papierkorb leeren"
            :is-loading="isLoadingConfirm"
            @confirm="onClearTrash"
        >
            <p class="m-0">Möchtest du wirklich den Papierkorb leeren?</p>
        </confirm-modal>
    </div>
</template>

<script>
import AppIcon from '@/components/ui/Icon.vue'
import DocumentThumb from '@/components/DocumentThumb.vue'
import Button from '@/components/ui/Button.vue'
import ConfirmModal from '@/components/ui/modals/ConfirmModal.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

export default {
    name: 'Home',

    components: {LoadingOverlay, AppButton: Button, DocumentThumb, AppIcon, ConfirmModal },

    data () {
        return {
            documents: [],
            showConfirmModal: false,
            isLoading: false,
            isLoadingConfirm: false,
        }
    },

    mounted () {
        this.loadDocuments()
    },

    methods: {
        async loadDocuments () {
            this.isLoading = true

            try {
                const response = await this.$http.get('/documents-trashed')
                this.documents = response.data
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                setTimeout(() => {
                    this.isLoading = false
                }, 1000)
            }
        },

        onDeleteDocument (documentId) {
            const index = this.documents.findIndex(x => x.id === documentId)
            this.documents.splice(index, 1)
        },

        async onClearTrash () {
            try {
                this.isLoadingConfirm = true
                const response = await this.$http.delete('/document-trash-clear')
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.$toast.open({ type: 'success', message: response.data.successHtml })
                this.showConfirmModal = false
                this.documents = []
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoadingConfirm = false
            }
        },
    },
}
</script>
